<div class="waiting-list-table-container">
  <!-- Leyenda de Prioridades -->
  <div
    class="mb-4 p-3 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700"
    >
    <div class="flex items-center gap-4 flex-wrap">
      <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">
        {{ 'waitingList.table.priority' | translate }}:
      </span>

      <div class="flex items-center gap-2">
        <span
          class="px-3 py-1.5 rounded text-xs font-semibold inline-block whitespace-nowrap"
          [ngStyle]="getPriorityStyles(1)"
          >
          {{ getPriorityLabel(1) }}
        </span>
      </div>

      <div class="flex items-center gap-2">
        <span
          class="px-3 py-1.5 rounded text-xs font-semibold inline-block whitespace-nowrap"
          [ngStyle]="getPriorityStyles(2)"
          >
          {{ getPriorityLabel(2) }}
        </span>
      </div>

      <div class="flex items-center gap-2">
        <span
          class="px-3 py-1.5 rounded text-xs font-semibold inline-block whitespace-nowrap"
          [ngStyle]="getPriorityStyles(3)"
          >
          {{ getPriorityLabel(3) }}
        </span>
      </div>

      <div class="flex items-center gap-2">
        <span
          class="px-3 py-1.5 rounded text-xs font-semibold inline-block whitespace-nowrap"
          [ngStyle]="getPriorityStyles(4)"
          >
          {{ getPriorityLabel(4) }}
        </span>
      </div>

      <div class="flex items-center gap-2">
        <span
          class="px-3 py-1.5 rounded text-xs font-semibold inline-block whitespace-nowrap"
          [ngStyle]="getPriorityStyles(5)"
          >
          {{ getPriorityLabel(5) }}
        </span>
      </div>
    </div>
  </div>

  @if (loading) {
    <div class="flex justify-center items-center h-64">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (!loading) {
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
      <p-table
        (onPage)="onPageChange($event)"
        currentPageReportTemplate="{{ 'waitingList.pagination' | translate }}"
        [first]="first"
        [lazy]="false"
        [loading]="loading"
        [paginatorDropdownAppendTo]="'body'"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [rows]="rows"
        [showCurrentPageReport]="true"
        [totalRecords]="totalRecords"
        [value]="waitingList"
        stripedRows
        >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'waitingList.table.firstName' | translate }}</th>
            <th>{{ 'waitingList.table.lastName' | translate }}</th>
            <th>{{ 'waitingList.table.email' | translate }}</th>
            <th>{{ 'waitingList.table.checkIn' | translate }}</th>
            <th>{{ 'waitingList.table.checkOut' | translate }}</th>
            <th class="min-w-48">{{ 'waitingList.table.notes' | translate }}</th>
            <th>{{ 'waitingList.table.priority' | translate }}</th>
            <th>{{ 'waitingList.table.status' | translate }}</th>
            <th>{{ 'waitingList.table.actions' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template let-entry pTemplate="body">
          <tr>
            <td>
              <span class="font-semibold">{{ entry.patient_info.first_name }}</span>
            </td>
            <td>
              <span class="font-semibold">{{ entry.patient_info.last_name }}</span>
            </td>
            <td>
              <span>{{ entry.patient_info.email }}</span>
            </td>
            <td>
              <span>{{ entry.desired_check_in | date : 'dd/MM/yyyy' }}</span>
            </td>
            <td>
              <span>{{ entry.desired_check_out | date : 'dd/MM/yyyy' }}</span>
            </td>
            <td>
              <span [title]="entry.notes" class="block max-w-xs">
                {{ truncateNotes(entry.notes, 50) }}
              </span>
            </td>
            <td>
              <span
                class="px-3 py-1.5 rounded text-xs font-semibold inline-block whitespace-nowrap"
                [ngStyle]="getPriorityStyles(entry.priority)"
                >
                {{ getPriorityLabel(entry.priority) }}
              </span>
            </td>
            <td>
              <p-tag [severity]="getStatusSeverity(entry.status)" [value]="entry.status"></p-tag>
            </td>
            <td>
              <div class="flex gap-2">
                <!-- Convertir a reservación (solo para entradas actionable) -->
                @if (entry.status === 'actionable') {
                  <p-button
                    (onClick)="onConvert(entry)"
                    [raised]="true"
                    icon="pi pi-check-circle"
                    [pTooltip]="'waitingList.actions.convertToReservation' | translate"
                    severity="success"
                    size="small"
                    tooltipPosition="top"
                    variant="outlined"
                    />
                }
                <!-- Convertir a reserva -->
                <p-button
                  (onClick)="onEdit(entry)"
                  [raised]="true"
                  icon="pi pi-arrow-right"
                  [pTooltip]="'waitingList.actions.convertToReservation' | translate"
                  severity="secondary"
                  size="small"
                  tooltipPosition="top"
                  variant="outlined"
                  />
                <!-- Eliminar -->
                <p-button
                  (onClick)="onDelete(entry)"
                  [raised]="true"
                  icon="pi pi-trash"
                  [pTooltip]="'waitingList.actions.delete' | translate"
                  severity="danger"
                  size="small"
                  tooltipPosition="top"
                  variant="outlined"
                  />
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="text-center p-4" colspan="9">
              <div class="text-gray-500 dark:text-gray-400">
                {{ 'waitingList.table.noEntries' | translate }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
